import React from 'react';
import { AiOutlineGithub, AiOutlineLinkedin, AiOutlineFacebook } from 'react-icons/ai';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className='bg-tertiary py-12'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row space-y-6 lg:space-y-0 items-center justify-between'>
          <div className='flex pt-5 gap-5'>
            <a href="https://www.linkedin.com/in/emtiazhossaine2/" target="_blank" rel="noopener noreferrer" className='flex gap-4 text-lg hover:text-[#067aee]'>
              <span className='text-3xl '><AiOutlineLinkedin /></span>
            </a>

            <a href="https://github.com/EmtiazHossainE2" target="_blank" rel="noopener noreferrer" className='flex gap-4 text-lg hover:text-[#2a8ad8]'>
              <span className='text-3xl '><AiOutlineGithub /></span>
            </a>
            <a href='https://www.facebook.com/EmtiazHossainE2' target="_blank" rel="noopener noreferrer" className='flex gap-4 text-lg hover:text-[#067aee]'>
              <span className='text-3xl '><AiOutlineFacebook /></span>
            </a>

          </div>
          <p className='text-paragraph opacity-80 text-[15px]'>
            &copy; {currentYear} Emtiaz Emon . All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
